import VueRouter, { RouteConfig } from 'vue-router'

const LayoutUnauth = () => import('../views/LayoutUnauth.vue')

const Login = () => import('../views/Login.vue')
const AuthForm = () => import('../views/AuthForm.vue')
const ContactUs = () => import('../views/ContactUs.vue')
const AuthFormQuick = () => import('../views/AuthFormQuick.vue')
const AuthInProgress = () => import('../views/AuthInProgress.vue')

export const loginRoute: RouteConfig = {
  path: 'login',
  name: 'login',
  component: Login,
  props: (route) => ({ ...route.query, ...route.params }),
}

export const authRoute: RouteConfig = {
  path: 'auth',
  name: 'auth',
  component: AuthForm,
  props: (route) => ({ ...route.query, ...route.params }),
}

export const contactUsRoute: RouteConfig = {
  path: '/contact-us',
  name: 'contact_us',
  component: ContactUs,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '联系我们',
    ignoreLogin: true,
  },
}

export const authFormQuickRoute: RouteConfig = {
  path: 'auth-form-quick',
  name: 'auth_form_quick',
  component: AuthFormQuick,
  props: (route) => ({ ...route.query, ...route.params }),
}

export const authInProgressRoute: RouteConfig = {
  path: 'auth-in-progress',
  name: 'auth_in_progress',
  component: AuthInProgress,
  props: (route) => ({ ...route.query, ...route.params }),
}

export default [
  {
    path: '/account',
    name: 'account',
    component: LayoutUnauth,
    children: [authRoute, loginRoute, contactUsRoute, authFormQuickRoute, authInProgressRoute],
  },
]

export function navigateToContactUs(router: VueRouter, qd?: string) {
  window.open(router.resolve({ name: contactUsRoute.name, query: { qd } }).href, '__blank')
}
